<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row class="page-intro">
            <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">

                <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>

                <transition name="fade">
                    <div v-if="!loading" class="padding">

                        <transition name="fade">
                            <div v-show="!showSlider" class="intro">
                                <div  class="mt-20">
                                    <div class="logo svg-wrapper svg-inline svg-rwd">
                                        <svg-vox-partners-club />
                                    </div>
                                    <div v-if="intro" class="lead">
                                        <div class="entry" v-html="intro.content"></div>
                                    </div>
                                    <div v-if="sliders" class="mb-20">
                                        <button class="btn btn-primary btn-auto" @click="goToSlider">Rozpocznij</button>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <transition name="long-fade">
                            <div v-if="showSlider" class="slider">
                                <ion-slides ref="IntroSlider" pager="true" :options="slideOpts" mode="md" @ionSlideDidChange="ionSlideDidChange">
                                    <ion-slide v-for="(item, index) in sliders" :key="index" :class="item.type" >
                                        <div class="item" >
                                            <h2 v-if="item.title" class="mb-1">{{item.title}}</h2>

                                            <template v-if="item.type == 'star'">
                                                <div class="svg-wrapper svg-rwd">
                                                    <svg-star class="svgStar" :ref="'svgStar_'+index" pause="true"></svg-star>
                                                </div>
                                            </template>

                                            <template v-if="item.type == 'circle'">
                                                <div class="svg-wrapper svg-rwd">
                                                    <svg-circle-progress class="svgCircle" :ref="'svgCircle_'+index" pause="true" percentage="43" theme="dark" label="miesięcznego planu"></svg-circle-progress>
                                                </div>
                                            </template>

                                            <template v-if="item.type == 'padlock'">
                                                <div class="svg-wrapper svg-rwd">
                                                    <svg-padlock-steps class="svgPadlock" :ref="'svgPadlock_'+index" pause="true" totalQuestions="2" passedQuestions="1" minCorrectReplies="1" theme="dark" label="poprawnych pytań <br>w miesiącu"></svg-padlock-steps>
                                                </div>
                                            </template>

                                            <template v-if="item.type == 'image'">
                                                <div class="image">
                                                    <ion-img :src="item.image" ></ion-img>
                                                </div>
                                            </template>

                                            <div v-if="item.content" class="entry content lead" v-html="item.content"></div>

                                            <div v-if="index == sliders.length - 1" class="mt-10 mb-10">
                                                <button class="btn btn-primary btn-auto" @click="goToNext">Dalej</button>
                                            </div>

                                        </div>
                                    </ion-slide>
                                </ion-slides>
                            </div>
                        </transition>

                    </div>
                </transition>

            </ion-col>
        </ion-row>
    </div>
</template>

<script>

    import SvgVoxPartnersClub from "../../components/svgplus/SvgVoxParntersClub.vue";
    import SvgCircleProgress from "../../components/svgplus/SvgCircleProgress.vue";
    import SvgPadlockSteps from "../../components/svgplus/SvgPadlockSteps.vue";
    import SvgStar from "../../components/svgplus/SvgStar.vue";
    import SliderServices from "../../services/SliderServices";

    export default {
        components: {
            SvgStar,
            SvgPadlockSteps,
            SvgCircleProgress,
            SvgVoxPartnersClub
        },
        name: "Intro",
        data: () =>({
            loading: true,
            errors: [],
            sliderCollecion: null,
            slideOpts : {
                effect: 'flip'
            },
            showSlider : false
        }),
        computed: {
            intro(){
                return this.sliderCollecion && this.sliderCollecion.length ? this.sliderCollecion[0] : null;
            },
            sliders(){
                return this.sliderCollecion && this.sliderCollecion.length ? this.sliderCollecion.slice(1) : null;
            }
        },
        methods: {

            getData(){
                this.loading = true
                SliderServices.getSlider()
                    .then( (response) => {
                        this.loading = false;
                        this.sliderCollecion = response.data.data;
                    })
                    .catch( (e) => {
                        this.errors.push(e.toString())
                    })
            },
            goToSlider(){
                this.showSlider = true;
                setTimeout(()=>{ this.setActiveSlide(); }, 300);
                // fix
                setTimeout(()=>{ this.setActiveSlide(); }, 900);
                setTimeout(()=>{ this.setActiveSlide(); }, 1500);
                setTimeout(()=>{ this.setActiveSlide(); }, 2100);
                // end fix
                this.$gtag.event('intro', 'gotoSlider')
            },

            goToNext(){
                this.$router.push({name:'Index'})
                this.$gtag.event('intro', 'gotoNext')
            },

            ionSlideDidChange(){
                this.setActiveSlide()
            },

            setActiveSlide(){

                let svg_class = ['svgStar', 'svgPadlock', 'svgCircle'];
                let activeSlide = this.$refs.IntroSlider.querySelector('.swiper-slide-active');

                let activeIndex = this.$refs.IntroSlider.getActiveIndex();
                if(activeIndex) {
                    activeIndex.then((index) => {
                    console.log('active', index);
                        svg_class.forEach((value) => {
//                        console.log(value, Boolean(activeSlide.querySelector('.'+value)));
                            if (Boolean(activeSlide.querySelector('.' + value)) === true) {
//                            console.log(value+'_'+index, this.$refs[value+'_'+index])
                                if (this.$refs[value + '_' + index]) this.$refs[value + '_' + index][0].playAnimate();
                            }
                        });
                    })
                        .catch((e) => {
                            this.errors.push(e.toString())
                        })
                }
            }

        },

        created(){
            this.getData();
        },

        mounted(){
        }

    }

</script>